export default __webpack_public_path__ + "static/media/stocks_selected.301e4655.svg";